(ns web3.forms.fields
  (:refer-clojure :exclude [resolve])
  (:require [web3.persistence.schema :as schema]
            [web3.components.persisted :as persisted]
            [web3.i18n :as i]
            [web3.view :as v]
            [web3.persistence.graphql :as g]
            [clojure.string :as str]))

(def resolve {:select persisted/select
              :text-input persisted/text-input
              :text-search (v/partial-props persisted/text-input {:kind :search})
              :model-search (v/partial-props persisted/text-input {:kind :model-search})
              :parent-selector (v/partial-props persisted/text-input {:kind :parent-selector})
              :file-upload persisted/file-upload})

(defn from-schema
  "Given the name of a registered field, render it, merging the provided props and children
   with those defined in the schema."
  [registered-name props & children]

  (let [registered-name (cond-> registered-name
                                (vector? registered-name) (last))
        {:keys [kind]
         schema-children :children :as schema-props} (get schema/form-fields registered-name)]
    [;; look up the field, based on its `:kind` in schema
     (resolve kind)

     ;; merge props from schema with provided props
     (-> schema-props
         (v/merge-props props)

         ;; validators should concat, not overwrite
         (update :validators (comp set into) (:validators schema-props))

         (assoc :key registered-name)
         (assoc :id (str (namespace registered-name) \_ (munge (name registered-name))))
         (assoc :label (or (:label props)
                           (:label schema-props)
                           ;; auto-fill label by looking up the namespaced field key in i18n
                           (i/get registered-name)))
         (dissoc :kind :children))

     ;; include children provided to `field`, or children in `schema`, if either exists.
     (or (seq children)
         schema-children)]))

(defn decode-referral-link [link]
  (when link
    (let [s (-> link (str/split #"/") last)
          link-no-phone (subs link 0 (- (count link) 10))
          ]
      (if (= (count s) 10)
       (str link-no-phone (schema/decode-phone-number s))
       link))))